import { NavigateFunction } from 'react-router-dom'
import {
  FlyoutOnboardingSectionName,
  type Sections,
} from '../../../../modules/flyOutOnboarding/types'

export const checkTerms = (
  values: Sections,
  page: FlyoutOnboardingSectionName
) => {
  return (values?.termsAndConditions?.[page] || []).every(term => !!term.value)
}

export const navigateToNextPage = (
  sectionName: FlyoutOnboardingSectionName,
  navigate: NavigateFunction,
  isManaged?: boolean
) => {
  if (
    sectionName === FlyoutOnboardingSectionName.LABRA_PARTNER_DETAILS &&
    !isManaged
  ) {
    navigate('/flyout/onboarding/cloud-settings/aws')
    return
  }
}
